export default __webpack_public_path__ + "static/media/98-02_footer_invoice.b3a0e4cf.png";